import { useState } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import {
  AddressBook,
  AddressBooksClient,
  AddressBookTypeEnum,
  AuthClient,
} from '../../../generated';
import { httpRequest } from '../../../utils';
import { QueryKeys } from '../../keys';

export const useAddressBooksPut = () => {
  const queryClient = useQueryClient();
  const [error, setError] = useState<string>('');
  const addressBooksPut = useMutation(
    async (addressBook: AddressBook) =>
      addressBook.addressBookTypeEnum === AddressBookTypeEnum.Private &&
      (await httpRequest(() =>
        new AddressBooksClient(new AuthClient()).addressBooksPut(addressBook),
      )),
    {
      onSuccess: () => {
        setError('');
        queryClient.invalidateQueries(QueryKeys.AddressBooksSearch);
        queryClient.invalidateQueries(QueryKeys.AddressBooksPrivate);
        queryClient.invalidateQueries(QueryKeys.AddressBooksCollection);
      },
      onError: (err: string) => setError(err as any),
    },
  );

  return { error, addressBooksPut };
};
